import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'

import { AuthShell } from '../components/AuthShell'
import {
  PreferenceCategory,
  PreferenceInfo,
  PreferenceInput,
  PreferenceLink,
  PreferenceScreen,
  PreferenceSubmit,
} from '../components/Preference'
import { authClient } from '../lib/auth-client'

export default function ResetPassword() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const token = params.get('token')
  const urlError = params.get('error')

  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)

  async function savePassword() {
    if (!token) {
      toast.error('Geen geldige resetlink.')
      return
    }
    if (password.length < 8) {
      toast.error('Wachtwoord moet minstens 8 tekens zijn')
      return
    }
    if (password !== confirm) {
      toast.error('Wachtwoorden komen niet overeen')
      return
    }
    setBusy(true)
    try {
      const { error: err } = await authClient.resetPassword({
        newPassword: password,
        token,
      })
      if (err) {
        toast.error(err.message || 'Reset mislukt')
        return
      }
      setDone(true)
      setTimeout(() => navigate('/login', { replace: true }), 1500)
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthShell>
      <PreferenceScreen title="Nieuw wachtwoord" backHref="/login">
        {!token || urlError ? (
          <PreferenceCategory filled>
            <PreferenceInfo
              title="Deze link is ongeldig of verlopen."
              className="text-red-300"
            />
            <PreferenceLink title="Terug naar inloggen" href="/login" />
          </PreferenceCategory>
        ) : done ? (
          <PreferenceCategory filled>
            <PreferenceInfo
              title="Wachtwoord bewaard"
              summary="Je wordt doorgestuurd naar inloggen…"
            />
          </PreferenceCategory>
        ) : (
          <PreferenceCategory filled>
            <PreferenceInput
              title="Nieuw wachtwoord"
              type="password"
              value={password}
              onChange={setPassword}
              autoComplete="new-password"
              minLength={8}
              placeholder="••••••••"
              autoFocus
            />
            <PreferenceInput
              title="Bevestig wachtwoord"
              type="password"
              value={confirm}
              onChange={setConfirm}
              autoComplete="new-password"
              minLength={8}
              placeholder="••••••••"
            />
            <PreferenceSubmit
              title={busy ? 'Bezig…' : 'Bewaren'}
              onPress={savePassword}
              disabled={busy || !password || !confirm}
            />
          </PreferenceCategory>
        )}
      </PreferenceScreen>
    </AuthShell>
  )
}
